import React, { PropTypes } from "react";
import { FormattedDate, FormattedTime, FormattedMessage } from "react-intl";
import ReactDOM from "react-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import classNames from "classnames";

import { EditButton } from "../../../../common/";
import { BasicFollowUpFields } from "./";
import { ENUM_DICT as NOTE_TYPES } from "./enums/followUpTypes";
import { toLocaleDate } from "../../../../common/dateHelper";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";

class NotesLineItem extends React.Component {
  constructor(props, context) {
    super(props, context);

    this._open = this._open.bind(this);
  }

  _open() {
    const button = this.refs.editButton;

    if (button) {
      const element = ReactDOM.findDOMNode(button);
      for (let key in element) {
        if (key.startsWith("__reactInternalInstance$")) {
          const instance = element[key]._currentElement._owner._instance;
          instance.refs.action.props.onClick();
          break;
        }
      }
    }
  }

  render() {
    const { followUp } = this.props;

    const contents = followUp.description;

    const editableFollowUp = this.props.createEditableFollowUpModel({
      ...followUp,
      description: contents,
    });
    const userName =
      followUp.createdByUserId && followUp.createdByUser && followUp.createdByUserId !== 1 ? (
        `${followUp.createdByUser.firstName
        } ${followUp.createdByUser.lastName.charAt(0)}.`
      ) : (
        <FormattedMessage id="members.followUps.types.systemNote" />
      );
    const iconClassNames = classNames({
      icon: true,
      [followUp.followUpOriginType && followUp.followUpOriginType.toLowerCase()]: true,
      open: followUp.followUpStatusType == "OPEN" && !!followUp.recipientUserId,
      closed: followUp.followUpStatusType == "CLOSED",
    });
    const lineClassNames = classNames({
      "line-item": true,
      system: !followUp.createdByUserId,
    });
    const tooltip = (
      <Tooltip id={followUp.followUpId} className="line-break-tooltip">
        {followUp.description}
      </Tooltip>
    );
    const titleKey =
      editableFollowUp.followUpStatusType == "OPEN"
        ? "members.followUps.editNote"
        : NOTE_TYPES[editableFollowUp.followUpType].key;
    const ViewTitle = (
      <FormattedMessage id={titleKey}>
        {(f) => <span className="icon note-origin manual">{f}</span>}
      </FormattedMessage>
    );
    const isArchivedMember = editableFollowUp.member && editableFollowUp.member.isArchived && !userHasAccess(FINTECH);
    const isArchivedClient = editableFollowUp.client && editableFollowUp.client.isArchived;
    const createdAtLocal = followUp.createdAt ? toLocaleDate(Date.parse(followUp.createdAt.split(".")[0] + "Z")) : undefined;
    editableFollowUp.date = createdAtLocal ? <FormattedDate value={createdAtLocal} year="numeric" month="long" day="2-digit" /> : createdAtLocal;
    editableFollowUp.deadline = followUp.deadline ? toLocaleDate(Date.parse(followUp.deadline.split(".")[0] + "Z")) : undefined;
    const editNoteButton = followUp.createdByUserId ? (
      <EditButton
        ref="editButton"
        props={{ type: this.props.type, needsActiveProperty: this.props.needsActiveProperty, isArchivedMember, isArchivedClient }}
        modalClassName={"modal-follow-ups extra-large-modal"}
        title={ViewTitle}
        form={BasicFollowUpFields}
        editFunction={this.props.updateNote}
        allowSubmission={!editableFollowUp.readOnly && !isArchivedMember && !isArchivedClient}
        data={editableFollowUp}
        readOnly={editableFollowUp.readOnly || isArchivedMember || isArchivedClient}
      />
    ) : (
      ""
    );

    return (
      <div className={lineClassNames} onClick={this._open}>
        <div className="header">
          <span className={iconClassNames} />
          <span className="name">{userName}</span>
          {followUp.attachmentsCount > 0 && (
            <span className="icon-attachment" />
          )}
          {followUp.commentsCount > 0 && (
            <span className="comment-count">
              <span>
                {followUp.commentsCount > 99
                  ? "99+"
                  : followUp.commentsCount}
              </span>
            </span>
          )}
          <span className="date">
            <FormattedTime
              value={createdAtLocal}
              hour="numeric"
              minute="numeric"
            />
            &nbsp;&nbsp;-&nbsp;&nbsp;
            <FormattedDate
              value={createdAtLocal}
              year="2-digit"
              month="2-digit"
              day="2-digit"
            />
          </span>
        </div>
        <span style={{ display: "none" }}>{editNoteButton}</span>
        {((contents.length > 255 || /\r|\n/.test(contents)) && (
          <OverlayTrigger placement="left" overlay={tooltip}>
            <p className="description tooltipped-description">{contents}</p>
          </OverlayTrigger>
        )) || <p className="description">{contents}</p>}
      </div>
    );
  }
}

NotesLineItem.propTypes = {
  createEditableFollowUpModel: PropTypes.func.isRequired,
  followUp: PropTypes.object.isRequired,
  type: PropTypes.string,
  updateNote: PropTypes.func.isRequired,
  needsActiveProperty: PropTypes.bool
};

export default NotesLineItem;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/NotesLineItem.js